import map from 'lodash/map';

import config from 'js/app/config';

import { getResources, itemsPerPage, resourceOrder } from 'bundles/directory-graphql/common/constants';
import type { ResourceName } from 'bundles/directory-graphql/common/constants';
import type { TitledLink } from 'bundles/directory-graphql/components/LinksContainer';

export const getDefaultResource = () => {
  return resourceOrder[0].name;
};

export const isValidResource = (resourceName: ResourceName) => getResources()[resourceName] !== undefined;

// Not using the full graphql type because we may have multiple different ones, so I'm just using
// the properties that are needed in this util so it can be as extensible as possible
export const getPartnerNames = (partners: { elements: { name: string }[] }) =>
  map(partners.elements, 'name').join(', ');

export const getQueryLinksPerPage = (queryLinks: Array<TitledLink>, page?: string): Array<TitledLink> => {
  const currentPage = page ? parseInt(page, 10) : 1;
  const start = (currentPage - 1) * itemsPerPage;
  return queryLinks.slice(start, start + itemsPerPage);
};

export const isValidPageNumber = (pageNumber: number, pageCount: number): boolean => {
  if (pageNumber > pageCount || pageNumber < 1) return false;
  return true;
};

export const generateHrefWithPreview = (baseUrl: string, isPreview?: boolean) => {
  const url = new URL(baseUrl, config.url.base);
  if (isPreview) url.searchParams.append('preview', '1');

  return url.toString();
};
